import moment from 'moment'
import '../../static/moment-timezone-with-data-2010-2020.min.js'

moment.updateLocale('zh-cn', {
  longDateFormat: {
    L: 'YYYY-MM-DD'
  }
})

moment.updateLocale('zh-cn', {
  longDateFormat: {
    LT: 'YYYY-MM-DD HH:mm:ss'
  }
})

export default moment



// WEBPACK FOOTER //
// ./src/util/date.js